export const GET_LANDINGS = 'landing/GET_LANDINGS';

export const UPDATE_LANDINGS_CACHE = 'landing/UPDATE_LANDINGS_CACHE';
export const UPDATE_LANDINGS_CACHE_SET = 'landing/UPDATE_LANDINGS_CACHE_SET';
export const UPDATE_LANDING_SEARCH_RESULTS = 'landing/UPDATE_LANDING_SEARCH_RESULTS';

export function getLandings(payload) {
  return { type: GET_LANDINGS, payload };
}
